import Vue from 'vue'
import Vuex from 'vuex'

import access from './services/access'
import agenda from './services/agenda'
import auth from './services/auth'
import card from './services/card'
import city from './services/city'
import clinic from './services/clinic'
import clinicType from './services/clinicType'
import inquiry from './services/inquiry'
import notification from './services/notification'
import review from './services/review'
import role from './services/role'
import special from './services/special'
import specialization from './services/specialization'
import user from './services/user'
import worker from './services/worker'

Vue.use(Vuex)

export default new Vuex.Store({
	/**
	 * This state needed for mobile responsive (some dynamical data)
	 */
	state: {
		Header: {
			title: '',
			first: {},
			second: {}
		}
	},
	mutations: {
		TITLE(state, title) {
			state.title = title
		},
		FIRST(state, data) {
			state.first = data
		},
		SECOND(state, data) {
			state.second = data
		}
	},
	modules: {
		access,
		agenda,
		auth,
		card,
		city,
		clinic,
		clinicType,
		inquiry,
		notification,
		review,
		role,
		special,
		specialization,
		user,
		worker
	}
})



// WEBPACK FOOTER //
// ./src/vuex/store.js